import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TransactionStatusFilter extends Component {
    state = {
        txnStatusLists:[],
        txnStatusValue: '',
        istxnStatusLoading: true
    };
    componentDidMount(){
        this.gettxnStatus(this.props.start_date,this.props.end_date);
    }
    resttxnStatusFilter() {
        this.setState({
            txnStatusValue: [],
        })
    }
    gettxnStatus(start_date, end_date){
        this.setState({
             txnStatusLists:[],
        txnStatusValue: [],
        istxnStatusLoading: true
        })
        axios.get(config.get('API_URL')+'/filters/get_transaction_status/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tender_mode, index) => {
                    this.state.txnStatusLists.push({value: tender_mode.transaction_status, label: tender_mode.transaction_status})
                });
            }
            this.setState({
                istxnStatusLoading: false
            })
        });

    }


    changetxnStatus(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.txnStatusLists.findIndex(obj => obj.value==ids.value);
                this.state.txnStatusLists.move(index,0).join(',');
            });
        }
        this.props.onSelecttxnStatus(optionSelected, tenderArray);
        this.setState({
            txnStatusValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="tender_mode"
                isMulti
                value={this.state.txnStatusValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changetxnStatus.bind(this)}
                options={this.state.txnStatusLists}
                placeholderButtonLabel="Select [Txn Status]"
                isLoading={this.state.istxnStatusLoading}
            />
        );

    }
}
export default TransactionStatusFilter;